import { Application } from 'stimulus';
const application = Application.start();

import BsmodalController from '../bsmodal_controller';
import RecaptchaV2Controller from '../recaptcha_v2_controller';

application.register('bsmodal', BsmodalController);
application.register('recaptcha_v2', RecaptchaV2Controller);
